// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"221720f6","272":"dd574c33","360":"d0421d61","380":"a8cd9f69","386":"f07e9491","397":"9bbbdce5","407":"6f033030","686":"948e6344","795":"a009da6b","803":"380246c4"}[chunkId] + ".chunk.js";
};